<template>
  <div class="columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile">
    <search-genre-list-item
      v-for="genre in genres"
      v-bind:key="genre.id"
      v-bind:genre="genre"
    ></search-genre-list-item>
  </div>
</template>

<script>
  import SearchGenreListItem from '@/components/SearchGenreListItem'

  export default {
    name: 'SearchGenreList',
    components: {
      SearchGenreListItem
    },
    props: {
      genres: {
        type: Array,
        required: true
      }
    }
  }
</script>
